import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, getIdTokenResult } from '@angular/fire/auth';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(Auth);
  const authService = inject(AuthService);
  const router = inject(Router);

  // See checkoutGuard for why this is required: on a fresh page load, Firebase's persisted
  // session hasn't rehydrated yet, so currentUser() can still read null for a real admin.
  await auth.authStateReady();

  const user = authService.currentUser();
  if (!user) {
    return router.createUrlTree(['/admin/login'], { queryParams: { returnUrl: state.url } });
  }

  const tokenResult = await getIdTokenResult(user);
  if (tokenResult.claims['role'] !== 'admin') {
    return router.createUrlTree(['/']);
  }

  return true;
};
